"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const FormLabel_1 = require("../Forms/FormLabel");
const FormikInput = props => {
    const { placeholder, formControl, labelTitle, currentInput, required, hasError } = props;
    return ((0, jsx_runtime_1.jsxs)("fieldset", { className: "form-field", children: [(0, jsx_runtime_1.jsx)(FormLabel_1.FormLabel, { title: labelTitle, required: required, htmlFor: formControl.key, hint: currentInput === null || currentInput === void 0 ? void 0 : currentInput.hint }), (0, jsx_runtime_1.jsx)(formik_1.Field, { className: `form-input ${hasError ? 'input-validation-error' : ''}`, placeholder: placeholder, id: formControl.key, name: formControl.key })] }));
};
exports.FormikInput = FormikInput;
